import React                   from 'react';
import {
  WithStyle,
  ResizableBox,
  ResizableBoxEnable,
  ResizableBoxSize,
  // ResizableBoxResizeCallback
}                              from 'rewire-ui';
import Paper                   from '@material-ui/core/Paper';
import {Theme}                 from '@material-ui/core/styles';
import { withStyles }          from '../utility/styles';

export const InfoPanelContext = React.createContext<any>({
  isOpenInfoPanel: true,

  openInfoPanel: () => {},
  closeInfoPanel: () => {},
});

const styles = (theme: Theme) => ({
  infoPanelRoot: {
    margin: '0px 3px 2px 10px',
    padding: '0px',
    display: 'flex',
    flexDirection: 'column',
    transition: theme.transitions.create(['min-width', 'max-width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.shorter,
    }),
  },
  infoPanelPaperRoot: {
    margin:'0px',
    padding: '0px',
    display: 'flex',
    height: '100%',
    flexDirection: 'column',
    justifyContent: 'stretch',
  },
  infoPanelViewRoot: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    flex: '1',
  },
});

export interface IInfoPanelProps {
  classes?: any;
  minimizedWidth?: number;
  minimizedEnable?: ResizableBoxEnable;
  initialSize?: ResizableBoxSize;
  minWidth?: string | number;
  minHeight?: string | number;
  maxWidth?: string | number;
  maxHeight?: string | number;
  bounds?: 'parent' | 'window' | HTMLElement;
  boundsByDirection?: boolean;
  enable?: ResizableBoxEnable;
}

export type InfoPanelProps = WithStyle<ReturnType<typeof styles>, IInfoPanelProps>;

interface IInfoPanelState {
  isOpenInfoPanel: boolean;

  openInfoPanel(): void;
  closeInfoPanel(): void;
}

class InfoPanel extends React.Component<InfoPanelProps, IInfoPanelState> {
  elevation: number;

  static defaultProps = {
    minimizedWidth: 36,
    minimizedEnable: {
      top: false,
      right: false,
      bottom: false,
      left: false,
      topRight: false,
      bottomRight: false,
      bottomLeft: false,
      topLeft: false,
    },
    defaultSize: {width: 350, height: '100%'},
    minWidth: 350,
    minHeight: '100%',
    maxWidth: 1200,
    maxHeight: '100%',
    enable: {
      top: false,
      right: false,
      bottom: false,
      left: true,
      topRight: false,
      bottomRight: false,
      bottomLeft: false,
      topLeft: false,
    },
    bounds: 'window' as const,
    boundsByDirection: true,
  };

  constructor(props: InfoPanelProps) {
    super(props);

    this.elevation = 4;
    this.state     = {
      isOpenInfoPanel: true,
      openInfoPanel: this.openInfoPanel,
      closeInfoPanel: this.closeInfoPanel,
    };
  }

  get isOpenInfoPanel() {
    return this.state.isOpenInfoPanel;
  }

  openInfoPanel = () => {
    this.setState({isOpenInfoPanel: true});
  };

  closeInfoPanel = () => {
    this.setState({isOpenInfoPanel: false});
  };

  // resizeCallback: ResizableBoxResizeCallback = (
  //   event: MouseEvent | TouchEvent,
  //   direction: any,
  //   refToElement: HTMLDivElement,
  //   delta: any,
  // ) => {
  //   const width = refToElement?.clientWidth;
  //   console.log(width);
  // }

  render() {
    // eslint-disable-next-line prefer-const
    let { minWidth, maxWidth, enable, ...restLetProps } = this.props;
    const {classes, children, minimizedWidth, minimizedEnable, ...restProps} = restLetProps;
    if (!this.isOpenInfoPanel) {
      minWidth = minimizedWidth;
      maxWidth = minimizedWidth;
      enable   = minimizedEnable;
    }

    return (
      <ResizableBox
        className={classes.infoPanelRoot}
        minWidth={minWidth}
        maxWidth={maxWidth}
        enable={enable}
        // onResizeStop={this.resizeCallback}
        {...restProps}
      >
        <Paper className={classes.infoPanelPaperRoot} elevation={this.elevation}>
          <div className={classes.infoPanelViewRoot}>
            <InfoPanelContext.Provider value={this.state}>
              {children}
            </InfoPanelContext.Provider>
          </div>
        </Paper>
      </ResizableBox>
    );
  }
}

export default withStyles<IInfoPanelProps>(styles, InfoPanel);
